import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@/styles/main.scss'
import colors from 'vuetify/lib/util/colors'
import * as VueGoogleMaps from 'vue2-google-maps'
import StaticMap from 'vue-static-map'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueYoutube from 'vue-youtube'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import './registerServiceWorker'
import VueEmojiPicker from 'vue-emoji-picker'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
// import 'vue2-timepicker/dist/VueTimepicker.css'

// GLOBAL FILTERS
import './filters/formatShortDate'

const fb = require('@/services/firebaseConfig.js')

Vue.use(Croppa)
Vue.use(VueEmojiPicker)
Vue.use(VueFacebookPixel, {
  router,
  debug: true
})
// Vue.use(VueYouTubeEmbed)
Vue.use(VueYoutube)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyClBFD7OmQ_rOx-P8u3P9Qz0EcN5SBMf-Q',
    libraries: 'places'
  },
  // Demonstrating how we can customize the name of the components
  installComponents: true
})
Vue.use(StaticMap)
Vue.use(Vuetify)
const opts = {
  iconfont: 'mdi', // 'md' || 'mdi' || 'fa' || 'fa4'
  customProperties: true,
  theme: {
    dark: localStorage.getItem('theme') === 'dark',
    themes: {
      dark: {
        primary: colors.deepOrange.base,
        secondary: colors.deepOrange.lighten2,
        accent: colors.lightBlue.base,
        error: colors.red.base,
        warning: colors.yellow.base,
        info: colors.blue.base,
        success: colors.green.base,
        panel: colors.grey.darken3,
        stText: colors.blue.base
      },
      light: {
        primary: colors.deepOrange.base,
        secondary: colors.deepOrange.lighten2,
        accent: colors.lightBlue.base,
        error: colors.red.base,
        warning: colors.yellow.base,
        info: colors.blue.base,
        success: colors.green.base,
        panel: colors.grey.lighten4,
        stText: colors.blue.base
      }
    }
  }
}

let vuetify = new Vuetify(opts)
Vue.config.productionTip = false

let app
fb.app.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({ router, vuetify, store, render: h => h(App) }).$mount('#app')
  }
})
